import { Component, EventEmitter, Input, Output } from '@angular/core';
import { GenerationStatusModel } from '@deployment-common/generation-status.model';
import { ValidatingHelper } from '@deployment-common/validating/validating.helper';

@Component({
    selector: 'adm4-deployment-validating',
    template: `
    <adm4-validating [validatingText]='"Validating..."'
      [validationDoneText]='validationTitle'
      [status]='generationStatus'>
      @if (isValidationSuccess) {
        <div class='success'>
          <span>No issues detected. </span>
          @if (showGenerationButtonVisible) {
            <span>
              You find the <a (click)='showGenerationResults.emit()'>generation results here</a>
            </span>
          }
        </div>
      }
    </adm4-validating>
    `,
    styleUrls: ['./deployment-validating.component.scss'],
    standalone: false
})
export class DeploymentValidatingComponent {
  @Input() generationStatus: GenerationStatusModel;
  @Input() showGenerationButtonVisible: boolean;
  @Output() showGenerationResults: EventEmitter<void> = new EventEmitter();

  get isValidationSuccess() {
    return ValidatingHelper.isAllSuccess(this.generationStatus);
  }

  get validationTitle() {
    return this.isValidationSuccess ? 'Validation successful' : 'Validation failed';
  }
}
